export default __webpack_public_path__ + "static/media/misc-fireplaceA-2048w.fbcfb6c8.png";